import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import { Col, Row, Modal } from 'antd';
import CreateNotification from '../../organisms/CreateNotification';
import NotificationList from '../../organisms/NotificationList';
import { getAll, removeById, restoreById, create } from '../../../services/notificacoes';

const SectionPadding = styled(Col)`
  padding: 0px 16px;
`;

export default function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      // eslint-disable-next-line no-use-before-define
      await getAllNotification();
    })();
  }, []);

  const getAllNotification = async () => {
    const data = await getAll();
    setNotifications(data);
  };

  const createNotificationByIdAndRefresh = async (body) => {
    setLoading(true);
    await create(body);
    await getAllNotification();
    setLoading(false);
  };

  const removeNotificationByIdAndRefresh = async (id) => {
    setLoading(true);
    await removeById(id);
    await getAllNotification();
    setLoading(false);
  };

  const restoreNotificationByIdAndRefresh = async (id) => {
    setLoading(true);
    await restoreById(id);
    await getAllNotification();
    setLoading(false);
  };

  const openNotification = (notification) => {
    Modal.info({
      centered: true,
      width: 560,
      title: notification.titulo,
      // eslint-disable-next-line react/no-danger
      content: <div dangerouslySetInnerHTML={{ __html: notification.mensagem }} />,
      okText: 'Ok',
    });
  };

  return (
    <Page
      projeto="Cooperativa"
      titulo="PO Notification"
    >
      <Row>
        <SectionPadding
          xs={24}
          md={12}
        >
          <CreateNotification
            loading={loading}
            onPreview={openNotification}
            onCreate={createNotificationByIdAndRefresh}
          />
        </SectionPadding>
        <SectionPadding
          xs={24}
          md={12}
        >
          <NotificationList
            loading={loading}
            onDelete={removeNotificationByIdAndRefresh}
            onRestore={restoreNotificationByIdAndRefresh}
            onPreview={openNotification}
            notificationList={notifications}
          />
        </SectionPadding>
      </Row>
    </Page>
  );
}
